const config = {
  api:
    window.location.host === 'votolegal.com.br'
    || window.location.host === 'votolegal.com'
    || window.location.host === '2020.votolegal.com.br'
    || window.location.host === '2020.votolegal.com'
		? 'https://api2020vl.appcivico.com'
		: 'https://votolegal-test-api.appcivico.com',
};

module.exports = config;



// WEBPACK FOOTER //
// ./_source/store/config/development.js